import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
import { DataGrid } from '@mui/x-data-grid';
import classNames from 'classnames';
import saveAs from 'file-saver';
import _ from 'lodash';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';
import { orderBy } from 'natural-orderby';
import qs from 'query-string';
import { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Form, Row } from 'react-bootstrap';
import { NavLink, withRouter } from 'react-router-dom';
import placeholderBackground from '../../../../../assets/images/placeholder-background.png';
import placeholderImage from '../../../../../assets/images/placeholder.jpg';
import Modal from '../../../../../components/Modal';
import RewardSidebar from '../../../../../components/Rewards/Sidebar';
import Searchbar from '../../../../../components/Searchbar';
import SpringLoader from '../../../../../components/SpringLoader/SpringLoader.js';
import AlertService from '../../../../../components/SweetAlert';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import { config } from '../../../../../config/index';
import { GET, newFetch, POST } from '../../../../../helpers/fetch';
import { to12Hr, toWeekDaysArrayFull } from '../../../../../helpers/moment';
import TransactionHistory from './TransactionHistory';
const { API_URL, SERVER_URL } = config;

const AssociateDetail = ({
  history,
  match: {
    params: { associate_id },
  },
  location: { search },
}) => {
  const clientID = parseInt(localStorage.getItem('client'), 10);
  let token = localStorage.getItem('token');
  let params = qs.parse(search);
  const [claims, setClaims] = useState([]);
  const [leaveSummary, setLeaveSummary] = useState([]);
  const [leaveSummaryId, setLeaveSummaryId] = useState();
  const [tabs, setTabs] = useState(['Overview', 'Shift Logs']);
  const [activeTab, setActiveTab] = useState('Overview');
  const [activeSubTab, setActiveSubTab] = useState('Redeemed Rewards');

  const [associate, setAssociate] = useState({});
  const [associatePoints, setAssociatePoints] = useState(null);
  const [associateSites, setAssociateSites] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [lastDayDate, setLastDayDate] = useState(null);
  const [resignDate, setResignDate] = useState(null);
  const [isTeamSupport, setIsTeamSupport] = useState(false);
  const [fixedSchedules, setFixedSchedules] = useState([]);
  const [scheduleLogs, setScheduleLogs] = useState([]);
  const [showRewardSidebar, setShowRewardSidebar] = useState(false);
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [showAssignPointsModal, setShowAssignPointsModal] = useState(false);
  const [showLeaveSummaryModal, setShowLeaveSummaryModal] = useState(false);
  const [modalMode, setModalMode] = useState('add');
  const [filterYearList, setFilterYearList] = useState([]);
  const [selectedfilterYearList, setSelectedfilterYearList] = useState('');
  const [loading, setLoading] = useState(false);
  const [shiftLogsData, setShiftLogsData] = useState([]);
  const [activeClient, setActiveClient] = useState(null);
  const [claimApprovers, setClaimApprovers] = useState([]);
  const [leaveApprovers, setLeaveApprovers] = useState([]);
  const [selectedApprovers, setSelectedApprovers] = useState({});
  const [siteAssociateArr, setSiteAssociateArr] = useState([]);
  const [associateList, setAssociateList] = useState([]);
  const [clientUsers, setClientUsers] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [selectedLeaveTypes, setSelectedLeaveTypes] = useState([]);
  const [selectedLeaveApprovers, setSelectedLeaveApprovers] = useState({});
  const [leaveTypeName, setLeaveTypeName] = useState([]);

  const [points, setPoints] = useState(0);
  const [reasons, setReasons] = useState([]);
  const [reason, setReason] = useState(0);
  const [remarks, setRemarks] = useState('');
  const [defaulValue, setDefaultValue] = useState('');
  const [clients, setClients] = useState([]);

  const [redeemedRewards, setRedeemedRewards] = useState([]);
  const [shiftPeriod, setShiftPeriod] = useState({
    shift_period_start: moment().startOf('month').format('YYYY-MM-DD'),
    shift_period_end: moment().format('YYYY-MM-DD'),
  });
  const [claimCreditLimitPercentage, setClaimCreditLimitPercentage] = useState(
    []
  );
  const [clientSettings, setClientSettings] = useState([]);
  const [data, setData] = useState([]);
  const [leaveList, setLeaveList] = useState([]);
  const [loadingLeave, setLoadingLeave] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [sortModel, setSortModel] = useState([
    { field: 'updatedAt', sort: 'desc' },
  ]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });

  //Leave Summary Form
  const [leaveTypeId, setLeaveTypeId] = useState('');
  const [maxLeaves, setMaxLeaves] = useState('');
  const [available, setAvailable] = useState('');
  const [taken, setTaken] = useState(0); // Usually from DB
  const [activeDate, setActiveDate] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [showTaken, setShowTaken] = useState(false);
  const [restDays, setRestDays] = useState([]);

  const useStyles = makeStyles({
    NameCell: {
      fontWeight: 900,
    },
  });

  const classes = useStyles();
  const columns = [
    {
      name: 'claim_type_name',
      label: 'Type',
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: (value) => {
          return {
            className: classNames({
              [classes.NameCell]: true,
            }),
          };
        },
      },
    },
    {
      name: 'amount',
      label: 'Amount',
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: (value) => {
          return {
            className: classNames({
              [classes.NameCell]: true,
            }),
          };
        },
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: (value) => {
          return {
            className: classNames({
              [classes.NameCell]: true,
            }),
          };
        },
      },
    },
    {
      name: 'createdAt',
      label: 'Date Filled',
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: (value) => {
          return {
            className: classNames({
              [classes.NameCell]: true,
            }),
          };
        },
      },
    },
  ];

  const leaveColumns = [
    {
      field: 'leave_type.leave_name',
      headerName: 'Leave Type',
      flex: 2,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span>{params.row.leave_type?.leave_name || '--'}</span>
      ),
    },
    {
      field: 'max_leaves',
      headerName: 'Max Per Year',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => <span>{params.row.max_leaves ?? '--'}</span>,
    },
    {
      field: 'available',
      headerName: 'Available',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => <span>{params.row.available ?? '--'}</span>,
    },
    {
      field: 'taken',
      headerName: 'Taken',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => <span>{params.row.taken ?? '--'}</span>,
    },
    {
      field: 'pending',
      headerName: 'Pending for Approval',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => <span>{params.row.pending ?? '--'}</span>,
    },
    {
      field: 'active_date',
      headerName: 'Active From',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span>
          {params.row.active_date
            ? moment(params.row.active_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            : '--'}
        </span>
      ),
    },
    {
      field: 'expiry_date',
      headerName: 'Active To',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      headerClassName: 'bold-header',
      renderCell: (params) => (
        <span>
          {params.row.expiry_date
            ? moment(params.row.expiry_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            : '--'}
        </span>
      ),
    },
  ];

  const options = {
    selectableRows: 'none',
    download: false,
    print: false,
    sort: false,
    viewColumns: false,
  };
  const fetchReasons = async () => {
    let api_path = `/reward/reason`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setReasons(response.data);
    }
  };

  const getApproverFullName = (
    approver,
    selectedId,
    clientUsers,
    associateList,
    admins
  ) => {
    if (!selectedId || selectedId === '0') return null;

    let sourceList = [];
    if (approver.value === 'client') sourceList = clientUsers || [];
    if (approver.value === 'associate') sourceList = associateList || [];
    if (approver.value === 'admin') sourceList = admins || [];

    const found = sourceList.find((item) => item.id.toString() === selectedId);

    return found ? `${found.first_name} ${found.last_name}` : null;
  };

  const capitalizeLabel = (label = '') =>
    label.charAt(0).toUpperCase() + label.slice(1);

  const fetchRestDays = async () => {
    try {
      const response = await newFetch(
        GET,
        `/associate/${associate_id}/rest-days`
      );
      if (response.success) {
        setRestDays(response.data.map((item) => item.day));
      }
    } catch (error) {
      console.log('Error fetching rest days:', error);
    }
  };

  const handleLeaveTypeClick = (leaveTypeId) => {
    setModalMode('edit');
    fetchLeaveDetails(leaveTypeId);
    setShowLeaveSummaryModal(true);
  };

  const fetchLeaveDetails = async (leaveTypeId) => {
    const res = await newFetch(
      POST,
      `/leavetypes/${leaveTypeId}/associate_id/${associate_id}`
    );

    if (res.success) {
      const data = res.data;

      // Set individual form fields
      setLeaveSummaryId(data.id || '');
      setLeaveTypeName(data.leave_type.name || '');
      setLeaveTypeId(data.leave_type_id || leaveTypeId);
      setMaxLeaves(data.max_leaves || '');
      setAvailable(data.available || '');
      setActiveDate(
        data.active_date ? formatDateForInput(data.active_date) : ''
      );
      setExpiryDate(
        data.expiry_date ? formatDateForInput(data.expiry_date) : ''
      );
      setTaken(data.taken ?? '0');

      // Keep the original data for reference if needed
      setSelectedLeaveTypes(data);
    } else {
      console.error('Failed to fetch leave type details:', res.message);
    }
  };

  const fetchLeaveTypesByAssociate = async () => {
    const api_path = `/leavetypes/option`;

    const response = await newFetch(POST, api_path, {
      associate_id: associate_id,
    });

    if (response.success) {
      setLeaveTypes(response.data); // assumes setLeaveTypes is your state setter
    } else {
      console.error('Failed to fetch leave types:', response.message);
    }
  };

  const saveLeaveSummary = async () => {
    // Validate required fields before sending
    if (!leaveTypeId || !activeDate || !expiryDate) {
      ToastUtil.error('Please fill in all required fields.');
      return;
    }

    // Validate date logic
    if (new Date(activeDate) > new Date(expiryDate)) {
      ToastUtil.error('Active From date must be before Active To date.');
      return;
    }

    // Validate numeric values
    if (maxLeaves < 0 || available < 0) {
      ToastUtil.error('Leave values cannot be negative.');
      return;
    }

    if (parseFloat(available) > parseFloat(maxLeaves)) {
      ToastUtil.error('Available leaves cannot exceed maximum leaves.');
      return;
    }

    // Determine API path and method based on mode
    const isEditMode = modalMode === 'edit';
    const api_path = isEditMode
      ? `/associate-leave-summary/${leaveSummaryId}` // Assuming you have leaveSummaryId for edit
      : `/associate-leave-summary`;
    const httpMethod = isEditMode ? 'PUT' : 'POST';

    // Payload based on your DB schema
    const payload = {
      associate_id: associate_id,
      leave_type_id: parseInt(leaveTypeId), // Ensure it's a number
      max_leaves: parseFloat(maxLeaves) || 0, // Handle empty strings
      available: parseFloat(available) || 0,
      taken: isEditMode ? parseFloat(taken) || 0 : 0, // Keep existing taken value in edit mode
      pending: 0,
      active_date: activeDate, // Format: 'YYYY-MM-DD'
      expiry_date: expiryDate, // Format: 'YYYY-MM-DD'
    };

    // For edit mode, you might want to include the ID in payload too (depends on your API)
    if (isEditMode && leaveSummaryId) {
      payload.id = leaveSummaryId;
    }

    try {
      const response = await newFetch(httpMethod, api_path, payload);

      if (response.success) {
        const successMessage = isEditMode
          ? 'Leave type updated successfully.'
          : 'Leave type added successfully.';

        ToastUtil.success(
          isEditMode ? 'Leave type updated.' : 'Leave type added.'
        );

        // Reset form fields only in add mode
        if (!isEditMode) {
          setLeaveTypeId('');
          setMaxLeaves('');
          setAvailable('');
          setActiveDate('');
          setExpiryDate('');
        }

        // Close modal and refresh data
        setShowLeaveSummaryModal(false);

        fetchLeave();
        // Refresh the leave summary data
        // fetchLeaveSummaryData(); // Uncomment if you have this function
      } else {
        const errorMessage = isEditMode
          ? 'Failed to update leave summary.'
          : 'Failed to add leave summary.';
        console.error(
          `${isEditMode ? 'Update' : 'Insert'} failed:`,
          response.message || 'Unknown error'
        );
        ToastUtil.error(response.message || errorMessage);
      }
    } catch (error) {
      const errorMessage = isEditMode
        ? 'An error occurred while updating leave summary. Please try again.'
        : 'An error occurred while adding leave summary. Please try again.';

      console.error(
        `Error while ${isEditMode ? 'updating' : 'inserting'} leave summary:`,
        error
      );
      ToastUtil.error(errorMessage);
    }
  };

  const fetchClients = async () => {
    let api_path = `/client/${clientID}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setClients(response.data);

      const assocTabs = [
        { title: 'Overview', enable: true },
        response.data.enable_smart_scheduler
          ? { title: 'Shift Logs', enable: true }
          : {},
        // { title: 'Claims', enable: data.data.client.enable_claims },
        // { title: 'Leave Summary', enable: data.data.client.enable_leave_credits},
      ];

      setTabs(assocTabs);
    }
  };

  const fetchLeave = async (newPaginationModel, newSortModel) => {
    try {
      setLoadingLeave(true);

      // Use the provided models or fall back to current state
      const currentPaginationModel = newPaginationModel || paginationModel;
      const currentSortModel = newSortModel || sortModel;

      // Default sorting if no sort model is provided
      const sortField =
        currentSortModel.length > 0 ? currentSortModel[0].field : 'updatedAt';
      const sortDirection =
        currentSortModel.length > 0 ? currentSortModel[0].sort : 'desc';

      const api_path = `/associate-leave-summary/${associate_id}`;
      const response = await newFetch(POST, api_path, {
        field: sortField,
        sort: sortDirection,
        page: currentPaginationModel.page,
        pageSize: currentPaginationModel.pageSize,
      });

      if (response.success) {
        setLeaveList(response.data.list);
        setTotalRows(response.data.total_record);
      } else {
        setLeaveList([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.error('Error fetching leave summary:', error);
      setLeaveList([]);
      setTotalRows(0);
    } finally {
      setLoadingLeave(false);
    }
  };

  const checkDefault = () => {
    return JSON.parse(reason).default_remarks;
  };

  const fetchAssociate = async () => {
    let url = `${API_URL}/associate/${associate_id}`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let data = await response.json();

      if (response.ok) {
        setAssociate(data.data);
        setActiveClient(data.data.client);
        setSiteAssociateArr(data.data.sites);
      } else {
        ToastUtil.error('Failed to fetch employees!');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);
  };

  const fetchAssociatePoints = async () => {
    let url = `${API_URL}/reward/associate/points/${associate_id}`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let data = await response.json();
      if (response.ok) {
        const total = associatePointsHandler(data.result.recordset);
        setAssociatePoints(total);
      } else {
        ToastUtil.error('Failed to fetch employee points!');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchClaims = async () => {
    try {
      let api_path = `/logs/claims/${associate_id}`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        let ResponseClaims = response.data;
        setClaims(ResponseClaims);
      } else {
        console.log(response.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchFixedSchedules = async () => {
    let url = `${API_URL}/associate/${associate_id}/fixed_schedule`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let data = await response.json();

      response.ok
        ? setFixedSchedules(data.data)
        : ToastUtil.error('Failed to fetch employees!');
    } catch (error) {
      console.log(error);
    }
  };

  const fetchClaimApprovers = async (site_id) => {
    if (!activeClient?.id) {
      console.log('Client ID is missing');
      return;
    }

    if (!token) {
      console.log('Token is missing');
      return;
    }

    const url = `${API_URL}/client/${activeClient.id}/site/${site_id}/claimapprovers`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();

        if (data.success) {
          const approvers = data.data.map((item, index) => ({
            name: item.site.name,
            id: item.id,
            value: item.type, // Value as type
            site_id: item.site_id,
          }));

          // Correct way to append new data
          setClaimApprovers((prev) => [...prev, ...approvers]);
        } else {
          console.log('Error:', data.message);
        }
      } else {
        console.log('HTTP Error:', response.statusText);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };

  const fetchLeaveApprovers = async () => {
    const fetch_path = `/client/${activeClient.id}/leaveapprovers`;

    if (!token) {
      console.log('Token is missing');
      return;
    }

    try {
      const response = await newFetch(GET, fetch_path);

      if (response.success) {
        const approvers = response.data.map((item, index) => ({
          id: item.id,
          value: item.type, // Using item.type as value
        }));

        setLeaveApprovers(approvers);
      } else {
        console.log('Error:', response.message);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };

  const handleAddNewLeaveType = async () => {
    setLeaveTypeId('');
    setMaxLeaves('');
    setAvailable('');
    setActiveDate('');
    setExpiryDate('');
    setSelectedLeaveTypes(null);

    setModalMode('add');
    setShowLeaveSummaryModal(true);
  };

  const fetchApprovers = async (type) => {
    let api_path = `/associate/${associate_id}/associateapprover/type/${type}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      const formattedData = {};

      response.data.forEach((item) => {
        if (type === 'claims') {
          formattedData[item.site_approval_id] = {
            site_approval_id: item.site_approval_id,
            source_id: String(item.source_id),
          };
        } else if (type === 'leaves') {
          formattedData[item.client_approval_id] = {
            client_approval_id: item.client_approval_id,
            source_id: String(item.source_id),
          };
        }
      });

      if (type === 'claims') {
        setSelectedApprovers(formattedData);
      } else if (type === 'leaves') {
        setSelectedLeaveApprovers(formattedData);
      }
    } else {
      console.log('Error:', response.message);
    }
  };

  const fetchAssociateListBySiteID = async (site_id) => {
    let api_path = `/associate/site/${site_id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let associatesData = response.data;
      let sorted = orderBy(associatesData, [
        (associate) => `${associate.first_name} ${associate.last_name}`,
      ]);
      setAssociateList(sorted);
    }
  };

  const fetchClientUsers = async () => {
    if (!activeClient?.id) {
      console.error('Error: activeClient.id is missing or invalid.');
      return;
    }

    let url = `${API_URL}/client/users/client_users/${activeClient.id}`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let data = await response.json();

      if (response.ok) {
        setClientUsers(data.data);
      }
    } catch (error) {
      console.error('Error fetching client users:', error);
      ToastUtil.error('An error occurred while fetching client users.');
    }
  };

  const fetchAdminsByClient = async () => {
    if (!activeClient?.id) {
      console.error('Error: activeClient.id is missing or invalid.');
      return;
    }

    let url = `${API_URL}/admin/client/${activeClient.id}`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let data = await response.json();

      if (response.ok) {
        setAdmins(data.data);
      }
    } catch (error) {
      console.error('Error fetching admins:', error);
      ToastUtil.error('An error occurred while fetching admins.');
    }
  };

  const shiftLogsMapping = async (scheduleData) => {
    let remappedData = _.uniqBy(
      scheduleData
        // .filter(
        //   (item) => String(new Date(item.date).getFullYear()) === String(year)
        // )
        .map((schedule) => ({
          date: moment(schedule.date).format('YYYY-MM'),
          monthYear: moment(schedule.date).format('MMMM YYYY'),
        }))
        .sort(
          (a, b) =>
            moment(b.date, 'YYYY-MM').format('YYYYMMDD') -
            moment(a.date).format('YYYYMMDD')
        ),
      'date'
    ).map((month) => ({
      ...month,
      dates: _.uniqBy(
        [...scheduleData].filter(
          (schedule) => moment(schedule.date).format('YYYY-MM') === month.date
        ),
        'date'
      )
        .sort(
          (a, b) =>
            moment(b.date).format('YYYYMMDD') -
            moment(a.date).format('YYYYMMDD')
        )
        .map((schedule) => ({
          date: moment(schedule.date).format('DD MMMM'),
          schedules: [...scheduleData]
            .filter(
              (s) =>
                moment(s.date).format('YYYYMMDD') ===
                moment(schedule.date).format('YYYYMMDD')
            )
            .sort((a, b) => a.shift_id - b.shift_id)
            .map((schedule) => ({
              statusString:
                schedule.status === 1
                  ? '-'
                  : schedule.status === 2
                  ? '-'
                  : schedule.status === 3
                  ? 'Late: Allowed to Work'
                  : schedule.status === 4
                  ? 'Late: Allowed to Work'
                  : schedule.status === 5
                  ? 'Late: Not Allowed to Work'
                  : schedule.status === 6
                  ? 'Absent'
                  : schedule.status === 7
                  ? 'Cancelled'
                  : schedule.status === 8
                  ? 'VTO'
                  : null,
              ...schedule,
            })),
        })),
    }));

    setScheduleLogs(remappedData);
  };

  const fetchScheduleLogs = async () => {
    setLoading(true);
    let api_path = `/associate/${associate_id}/schedule/${
      shiftPeriod.shift_period_start
    }/${shiftPeriod.shift_period_end}/${false}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      // sort by created_by
      let scheduleData = response.data;
      setShiftLogsData(response.data);
      let currentDate = new Date();
      shiftLogsMapping(scheduleData);

      let yearList = [];
      for (let schedule of scheduleData) {
        if (!yearList.includes(new Date(schedule.date).getFullYear())) {
          yearList.push(new Date(schedule.date).getFullYear());
        }
      }

      setFilterYearList(yearList);
      setLoading(false);
    }
  };

  const handleDownloadShiftLogs = async () => {
    setLoading(true);
    let url = `${API_URL}/associate/${associate_id}/schedule/${
      shiftPeriod.shift_period_start
    }/${shiftPeriod.shift_period_end}/${true}`;

    try {
      let response = await fetch(url, {
        method: 'GET',
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let responseData = await response.json();

      if (response.ok) {
        const filename = `Shiftlogs.xlsx`;
        const buffer = responseData.data.buffer.data;
        const arraybuffer = Uint8Array.from(buffer).buffer;

        const blob = new Blob([arraybuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        saveAs(blob, filename);
      } else {
        ToastUtil.error(responseData.message);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const fetchTransactionHistory = async () => {
    let api_path = `/reward/history_transaction/${associate_id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) setTransactionHistory(response.results);
  };

  const fetchRedeemedRewards = async () => {
    let api_path = `/reward/associate/${associate_id}/redeemed`;
    let response = await newFetch(GET, api_path);
    if (response.success) setRedeemedRewards(response.data);
  };

  const handleCloseAssignPointModal = () => {
    setPoints(0);
    setReason(0);
    setRemarks('');
    setShowAssignPointsModal(false);
  };

  const handleCloseLeaveSummaryModal = () => {
    setShowLeaveSummaryModal(false);
  };

  const handleSubmitAsssignPoints = async (e) => {
    e.preventDefault();

    if (JSON.parse(reason).points <= 0 && points <= 0) {
      ToastUtil.error('Please assign points!');
      return false;
    }

    if (reason == 0) {
      ToastUtil.error('Please select reason!');
      return false;
    }

    if (reason !== 0 && JSON.parse(reason).reason === 'Refund' && !remarks) {
      ToastUtil.error('Please enter remarks!');
      return false;
    }

    if (
      await AlertService.confirm(
        '',
        `Are you sure you want to assign ${
          JSON.parse(reason).points > 0 ? JSON.parse(reason).points : points
        } points to ${associate.first_name} ${associate.last_name}?`
      )
    ) {
      try {
        let data = {
          points:
            JSON.parse(reason).points > 0 ? JSON.parse(reason).points : points,
          associates: [associate_id],
          reason_id: JSON.parse(reason).id,
          remarks,
        };
        let api_path = `/reward/point`;
        let response = await newFetch(POST, api_path, data);

        if (response.success) {
          ToastUtil.success(response.message);
          window.location.reload();
        }
      } catch (err) {
        ToastUtil.error(err);
      }
    }
  };

  const handleSubmitLeaveSummary = async (e) => {
    e.preventDefault();

    if (JSON.parse(reason).points <= 0 && points <= 0) {
      ToastUtil.error('Please assign points!');
      return false;
    }

    if (reason == 0) {
      ToastUtil.error('Please select reason!');
      return false;
    }

    if (reason !== 0 && JSON.parse(reason).reason === 'Refund' && !remarks) {
      ToastUtil.error('Please enter remarks!');
      return false;
    }

    if (
      await AlertService.confirm(
        '',
        `Are you sure you want to assign ${
          JSON.parse(reason).points > 0 ? JSON.parse(reason).points : points
        } points to ${associate.first_name} ${associate.last_name}?`
      )
    ) {
      try {
        let data = {
          points:
            JSON.parse(reason).points > 0 ? JSON.parse(reason).points : points,
          associates: [associate_id],
          reason_id: JSON.parse(reason).id,
          remarks,
        };
        let api_path = `/reward/point`;
        let response = await newFetch(POST, api_path, data);

        if (response.success) {
          ToastUtil.success(response.message);
          window.location.reload();
        }
      } catch (err) {
        ToastUtil.error(err);
      }
    }
  };

  const handleLeaveSubmit = (e) => {
    e.preventDefault();
    saveLeaveSummary();
  };

  const handleSearchCarts = () => {
    //   let filtered = [...associates].filter(associate => {
    //     let name = `${associate.first_name} ${associate.last_name}`
    //     return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1
    // })
    // setFilteredAssociates(filtered)
  };

  const associatePointsHandler = (data) => {
    const finalTotalPoints = data.reduce((total, points) => {
      let computedExpiredAndUsePoints =
        parseFloat(points.total_expired) + parseFloat(points.total_used);
      let totalEarnedBalance =
        parseFloat(points.total_earned) - computedExpiredAndUsePoints;

      return total + totalEarnedBalance;
    }, 0);

    return finalTotalPoints;
  };

  const fetchSiteSettings = async (siteID) => {
    const api_path = `/dashboard/site_settings/site/${siteID}`;
    const response = await newFetch(GET, api_path);
    if (response.success) {
      return response?.data;
    }
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD format
  };

  useEffect(() => {
    if (checkDefault() != null) {
      setRemarks(checkDefault());
    } else {
      setRemarks('');
    }
  }, [reason]);

  useEffect(() => {
    fetchClients();
    fetchAssociate();
    fetchClaims();
    fetchFixedSchedules();
    fetchScheduleLogs();
    fetchLeaveTypesByAssociate();
    fetchRestDays();
    //fetchLeaves();
  }, []);

  useEffect(() => {
    fetchLeave(paginationModel, sortModel);
  }, [sortModel, paginationModel]);

  useEffect(() => {
    fetchScheduleLogs();
  }, [shiftPeriod]);

  useEffect(() => {
    params.tab && setActiveTab(params.tab);
  }, [params.tab]);

  useEffect(() => {
    params.sub && setActiveTab(params.sub);
  }, [params.sub]);

  useEffect(() => {
    if (associate && associate.sites) {
      setAssociateSites(associate.sites);
    } else {
      setAssociateSites(null);
    }
  }, [associate]);

  useEffect(() => {
    setData(leaveList !== undefined ? leaveList : []);

    leaveList !== undefined && setLoadingLeave(false);
  }, [leaveList]);

  useEffect(() => {
    const fetchAllClaimApprovers = async () => {
      if (siteAssociateArr && siteAssociateArr.length > 0) {
        siteAssociateArr.forEach((item) => {
          if (item.id) {
            fetchClaimApprovers(item.id);
            fetchLeaveApprovers(item.id);
            setClaimCreditLimitPercentage((prevState) => {
              return [
                ...prevState,
                {
                  site: item.id,
                  creditLimit: item.claim_limit,
                  creditPercentage: item.claim_percentage,
                  claimNoReceipts: item.claim_no_receipt,
                  safetyShoesCreditLimit: item.ss_claim_limit,
                },
              ];
            });
          }
        });

        // Get unique site IDs to prevent duplicate fetching
        const uniqueSiteIds = [
          ...new Set(siteAssociateArr.map((item) => item.id)),
        ];

        // Filter out any undefined or null site IDs
        const validSiteIds = uniqueSiteIds.filter((id) => id);

        const allSiteSettingsArrays = await Promise.all(
          validSiteIds.map((siteId) => fetchSiteSettings(siteId))
        );

        // Set the state with all approvers at once
        setClientSettings(allSiteSettingsArrays);
      }
    };

    fetchAllClaimApprovers();
  }, [siteAssociateArr]);

  useEffect(() => {
    if (claimApprovers && claimApprovers.length > 0) {
      claimApprovers.forEach((approver) => {
        if (approver.value === 'associate' && approver.site_id) {
          fetchAssociateListBySiteID(approver.site_id);
        }
      });
      fetchApprovers('claims');
    }
  }, [claimApprovers]);

  useEffect(() => {
    if (leaveApprovers && leaveApprovers.length > 0) {
      fetchApprovers('leaves');
    }
  }, [leaveApprovers]);

  useEffect(() => {
    fetchClientUsers();
    fetchAdminsByClient();
  }, [activeClient]);

  useEffect(() => {
    if (associateSites) {
      const sortStartDate = [...associateSites].sort(
        (a, b) =>
          moment(a.start_date).format('YYYYMMDD') -
          moment(b.start_date).format('YYYYMMDD')
      );
      const sortLastDayDate = [...associateSites].sort(
        (a, b) =>
          moment(a.last_day_date).format('YYYYMMDD') -
          moment(b.last_day_date).format('YYYYMMDD')
      );
      const sortResignDate = [...associateSites].sort(
        (a, b) =>
          moment(a.resign_date).format('YYYYMMDD') -
          moment(b.resign_date).format('YYYYMMDD')
      );

      const startDateObj = sortStartDate.length > 0 ? sortStartDate[0] : null;
      const lastDayDateObj =
        sortLastDayDate.length > 0 ? sortLastDayDate.pop() : null;
      const resignDateObj =
        sortResignDate.length > 0 ? sortResignDate.pop() : null;

      const startDate =
        startDateObj && startDateObj.start_date
          ? moment(startDateObj.start_date).format('DD/MM/YYYY')
          : '-';
      const lastDayDate =
        lastDayDateObj && lastDayDateObj.last_day_date
          ? moment(lastDayDateObj.last_day_date).format('DD/MM/YYYY')
          : '-';
      const resignDate =
        resignDateObj && resignDateObj.resign_date
          ? moment(resignDateObj.resign_date).format('DD/MM/YYYY')
          : '-';

      setStartDate(startDate);
      setLastDayDate(lastDayDate);
      setResignDate(resignDate);

      let checkIsTeamSupport = [...associateSites].find(
        (site) => site.is_team_support === true
      );

      setIsTeamSupport(checkIsTeamSupport);
    }
  }, [associateSites]);

  const periodFilterHandler = (period, e) => {
    if (e.target.value) {
      if (period === 'start') {
        setShiftPeriod({
          shift_period_end: shiftPeriod.shift_period_end,
          shift_period_start: e.target.value,
        });
      } else {
        setShiftPeriod({
          shift_period_start: shiftPeriod.shift_period_start,
          shift_period_end: e.target.value,
        });
      }
    }
  };

  useEffect(() => {
    fetchClients();
  }, [clientID]);

  return (
    <>
      <div
        className="d-flex bg-white justify-content-between"
        style={{ padding: '3rem' }}
      >
        <div className="d-flex flex-column">
          <NavLink
            to="/associates"
            className="text-decoration-none"
            style={{ color: 'inherit' }}
          >
            <div style={{ color: '#0d6efd' }}>
              <i className="fas fa-chevron-left pe-2"></i>Back to Employee
              Management
            </div>
          </NavLink>
          <div className="d-flex align-items-center justify-content-center pt-4">
            <div>
              <img
                src={
                  associate.image
                    ? `${SERVER_URL}/${associate.image}`
                    : placeholderImage
                }
                alt="default"
                className="rounded-circle border me-3"
                style={{ height: '6rem', width: '6rem' }}
              />
            </div>
            <div className="d-flex flex-column">
              <h5>{associate.full_name}</h5>
              <div className="d-flex">
                {isTeamSupport && (
                  <span className="badge rounded-pill bg-secondary me-2 p-2">
                    Team Support/Fixed Schedule
                  </span>
                )}
                {associate.active != undefined && !associate.active && (
                  <span className="badge rounded-pill bg-danger me-2 p-2">
                    Deactivated
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex mt-auto">
          <button
            onClick={() =>
              history.push(`/associates/associate/${associate_id}/edit`)
            }
            className="btn btn-outline-brand rounded adjust-fs adjust-shadow"
            style={{ width: '200px' }}
          >
            Edit Profile
          </button>
        </div>
      </div>

      <div className="d-flex align-items-start">
        <div
          className="d-flex flex-column flex-grow-1"
          style={{
            marginTop: '1.5rem',
            marginLeft: '3rem',
            marginRight: '3rem',
            marginBottom: '3rem',
          }}
        >
          <div className="d-flex justify-content-start">
            {tabs
              .filter((tab) => tab.enable)
              .map((tab) => (
                <div
                  key={tab.title}
                  className="pb-3 flex-shrink-0"
                  onClick={() =>
                    history.push({
                      pathname: `/associates/associate/${associate.id}`,
                      search: qs.stringify({
                        tab: tab.title,
                      }),
                    })
                  }
                >
                  <div
                    style={
                      activeTab === tab.title
                        ? {
                            cursor: 'pointer',
                            marginRight: '1.5rem',
                            paddingBottom: '1rem',
                            marginBottom: '1rem',
                            borderBottom: '5px #466ea5 solid',
                          }
                        : {
                            cursor: 'pointer',
                            marginRight: '1.5rem',
                            paddingBottom: '1rem',
                            marginBottom: '1rem',
                          }
                    }
                  >
                    <strong
                      className={
                        activeTab === tab.title ? 'text-brand' : 'text-muted'
                      }
                    >
                      {tab.title}
                    </strong>
                  </div>
                </div>
              ))}
          </div>
          <div className="d-flex flex-column">
            {activeTab === 'Overview' && (
              <>
                <div
                  className="card bg-white text-dark shadow rounded mb-4"
                  style={{ marginLeft: '3rem', marginRight: '3rem' }}
                >
                  <div className="card-body">
                    <div className="container-fluid d-flex">
                      <div style={{ width: '15rem' }} className="p-2 m-2">
                        <strong>Employee Information</strong>
                        <p className="pt-2 text-muted">
                          View and edit employee information
                        </p>
                      </div>
                      <div className="flex-grow-1 p-2 m-2">
                        <div className="row pb-3">
                          <div className="col-sm-4">
                            <strong>First Name</strong>
                            <p className="pt-2">{associate.first_name}</p>
                          </div>
                          <div className="col-sm-4">
                            <strong>Last Name</strong>
                            <p className="pt-2">{associate.last_name}</p>
                          </div>
                        </div>
                        <div className="row pb-3">
                          <div className="col-sm-4">
                            <strong>Employee No.</strong>
                            <p className="pt-2">{associate.employee_no}</p>
                          </div>
                          <div className="col-sm-4">
                            <strong>Employee ID</strong>
                            <p className="pt-2">{associate.employee_id}</p>
                          </div>
                        </div>
                        <div className="row pb-3">
                          <div className="col-sm-4">
                            <strong>Date of Birth</strong>
                            <p className="pt-2">
                              {associate.date_of_birth
                                ? moment(associate.date_of_birth).format(
                                    'DD MMMM YYYY'
                                  )
                                : '-'}
                            </p>
                          </div>
                          <div className="col-sm-4">
                            <strong>PB Candidate ID</strong>
                            <p className="pt-2">{associate.pb_cand_id}</p>
                          </div>
                        </div>
                        <div className="row pb-3">
                          <div className="col">
                            <strong>Email</strong>
                            <p className="pt-2">{associate.email}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="card bg-white text-dark shadow rounded mb-4"
                  style={{ marginLeft: '3rem', marginRight: '3rem' }}
                >
                  <div className="card-body">
                    <div className="container-fluid d-flex">
                      <div style={{ width: '15rem' }} className="p-2 m-2">
                        <strong>Assigned To</strong>
                        <p className="pt-2 text-muted">
                          Manage client and site assignation
                        </p>
                      </div>
                      <div className="flex-grow-1 p-2 m-2">
                        <div className="row pb-3">
                          <div className="col-sm-12">
                            <strong>Client</strong>
                            <p className="pt-2">
                              {associate.client ? associate.client.name : ''}
                            </p>
                          </div>
                        </div>
                        <div className="row pb-3">
                          <div className="col-sm-12">
                            <strong>Site</strong>
                            <div className="d-flex pt-3">
                              {associateSites &&
                                associateSites.map((site) => (
                                  <span
                                    key={site.id}
                                    className="badge rounded-pill bg-secondary me-2"
                                  >
                                    {site.name}
                                  </span>
                                ))}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <strong>Start Date</strong>
                            <p className="pt-2">{startDate}</p>
                          </div>
                          <div className="col-sm-4">
                            <strong>Resign Date</strong>
                            <p className="pt-2">{resignDate}</p>
                          </div>
                          <div className="col-sm-4">
                            <strong>Actual Last Day</strong>
                            <p className="pt-2">{lastDayDate}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {activeClient && activeClient.enable_claims === true && (
                  <div
                    className="card bg-white text-dark shadow rounded mb-4"
                    style={{ marginLeft: '3rem', marginRight: '3rem' }}
                  >
                    <div className="card-body">
                      <div className="container-fluid d-flex">
                        <div style={{ width: '15rem' }} className="p-2 m-2">
                          <strong>Claims</strong>
                          <p className="pt-2 text-muted">
                            Assign limits, percentage and approvers of claims.
                          </p>
                        </div>
                        <div className="flex-grow-1 p-2 m-2">
                          <Card className="mb-4">
                            <CardHeader>
                              <strong>Staff Purchase Settings</strong>
                            </CardHeader>
                            <CardBody>
                              {clientSettings.length > 0 &&
                                clientSettings.map((item, index) => {
                                  const siteData =
                                    claimCreditLimitPercentage.find(
                                      (s) => s.site === item.id
                                    );

                                  return (
                                    <Row
                                      key={`${item.id}-${index}`}
                                      className="mb-4"
                                    >
                                      <strong className="fw-bold">
                                        {item.name}
                                      </strong>

                                      {item?.enable_claim_limit && (
                                        <Form.Group as={Col} md="4">
                                          <Form.Label>
                                            <strong className="text-muted">
                                              Credit Limit
                                            </strong>
                                          </Form.Label>
                                          <p>{siteData?.creditLimit || ''}</p>
                                        </Form.Group>
                                      )}

                                      {item?.enable_claim_percentage && (
                                        <Form.Group as={Col} md="4">
                                          <Form.Label>
                                            <strong className="text-muted">
                                              Credit Percentage (%)
                                            </strong>
                                          </Form.Label>
                                          <p>
                                            {siteData?.creditPercentage || ''}
                                          </p>
                                        </Form.Group>
                                      )}

                                      {item?.enable_claim_receipt && (
                                        <Form.Group as={Col} md="4">
                                          <Form.Label>
                                            <strong className="text-muted">
                                              No. of Claim Receipts
                                            </strong>
                                          </Form.Label>
                                          <p>
                                            {siteData?.claimNoReceipts || ''}
                                          </p>
                                        </Form.Group>
                                      )}

                                      {!item?.enable_claim_limit &&
                                        !item?.enable_claim_percentage && (
                                          <p className="text-muted">
                                            Credit Limits & Percentage for
                                            Claims Settings are disabled.
                                          </p>
                                        )}
                                    </Row>
                                  );
                                })}
                            </CardBody>
                          </Card>
                          <Card className="mb-4">
                            <CardHeader>
                              <strong>Safety Shoes Settings</strong>
                            </CardHeader>
                            <CardBody>
                              {clientSettings.length > 0 &&
                                clientSettings.map((item, index) => {
                                  const siteData =
                                    claimCreditLimitPercentage.find(
                                      (s) => s.site === item.id
                                    );

                                  return (
                                    <Row
                                      key={`${item.id}-${index}`}
                                      className="mb-4"
                                    >
                                      <strong className="fw-bold">
                                        {item.name}
                                      </strong>

                                      {item?.enable_ss_claim_limit && (
                                        <Form.Group as={Col} md="4">
                                          <Form.Label>
                                            <strong className="text-muted">
                                              Safety Shoes Credit Limit
                                            </strong>
                                          </Form.Label>
                                          <p>
                                            {siteData?.safetyShoesCreditLimit ||
                                              ''}
                                          </p>
                                        </Form.Group>
                                      )}

                                      {!item?.enable_ss_claim_limit && (
                                        <p className="text-muted">
                                          Safety Shoes Credit Limits for Claims
                                          Settings are disabled.
                                        </p>
                                      )}
                                    </Row>
                                  );
                                })}
                            </CardBody>
                          </Card>
                          <Card className="mb-4">
                            <CardHeader>
                              <strong>Approvers</strong>
                            </CardHeader>
                            <CardBody>
                              {claimApprovers && claimApprovers.length > 0 ? (
                                Object.entries(
                                  claimApprovers.reduce((acc, approver) => {
                                    acc[approver.name] =
                                      acc[approver.name] || [];
                                    acc[approver.name].push(approver);
                                    return acc;
                                  }, {})
                                )
                                  .sort(([siteNameA], [siteNameB]) =>
                                    siteNameA.localeCompare(siteNameB)
                                  )
                                  .map(([siteName, approvers]) => (
                                    <div key={siteName} className="mb-4">
                                      {/* Site Name as Title */}
                                      <h5 className="fw-bold">{siteName}</h5>
                                      {approvers.map((approver, index) => (
                                        <div
                                          key={approver.id}
                                          className="row align-items-center mb-2"
                                        >
                                          {/* Approver Label */}
                                          <div className="col-md-3 fw-bold">
                                            Approver {index + 1}
                                          </div>

                                          {/* Capitalized Label Column */}
                                          <div className="col-md-4">
                                            {approver.value
                                              .charAt(0)
                                              .toUpperCase() +
                                              approver.value.slice(1)}
                                          </div>

                                          <div className="col-md-5">
                                            {selectedApprovers[approver.id]
                                              ?.source_id &&
                                            selectedApprovers[approver.id]
                                              ?.source_id !== '0' ? (
                                              <div className="form-control-plaintext">
                                                {approver.value === 'client' &&
                                                  (() => {
                                                    const user =
                                                      clientUsers?.find(
                                                        (u) =>
                                                          u.id.toString() ===
                                                          selectedApprovers[
                                                            approver.id
                                                          ].source_id
                                                      );
                                                    return user
                                                      ? `${user.first_name} ${user.last_name}`
                                                      : '';
                                                  })()}

                                                {approver.value ===
                                                  'associate' &&
                                                  (() => {
                                                    const associate =
                                                      associateList?.find(
                                                        (a) =>
                                                          a.id.toString() ===
                                                          selectedApprovers[
                                                            approver.id
                                                          ].source_id
                                                      );
                                                    return associate
                                                      ? `${associate.first_name} ${associate.last_name}`
                                                      : '';
                                                  })()}

                                                {approver.value === 'admin' &&
                                                  (() => {
                                                    const admin = admins?.find(
                                                      (a) =>
                                                        a.id.toString() ===
                                                        selectedApprovers[
                                                          approver.id
                                                        ].source_id
                                                    );
                                                    return admin
                                                      ? `${admin.first_name} ${admin.last_name}`
                                                      : '';
                                                  })()}
                                              </div>
                                            ) : (
                                              <div className="text-muted">
                                                Not selected
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  ))
                              ) : (
                                <div className="text-center p-4">
                                  No Records Found
                                </div>
                              )}
                            </CardBody>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {activeClient && activeClient.enable_leave_credits === true && (
                  <div
                    className="card bg-white text-dark shadow rounded mb-4"
                    style={{ marginLeft: '3rem', marginRight: '3rem' }}
                  >
                    <div className="card-body">
                      <div className="container-fluid d-flex">
                        <div style={{ width: '15rem' }} className="p-2 m-2">
                          <strong>Leaves</strong>
                          <p className="pt-2 text-muted">
                            Assign leave credits and designate leave approvers.
                          </p>
                        </div>
                        <div className="flex-grow-1 p-2 m-2">
                          <Card className="mb-4">
                            <CardHeader className="d-flex justify-content-between align-items-center">
                              <strong>Leave Summary</strong>
                            </CardHeader>

                            <CardBody>
                              <div className="table-responsive rounded shadow bg-white">
                                <Box sx={{ width: '100%' }}>
                                  <DataGrid
                                    columns={leaveColumns}
                                    rows={data || []}
                                    rowCount={totalRows || 1}
                                    loading={loadingLeave}
                                    pageSizeOptions={[
                                      10, 20, 30, 40, 50, 80, 100,
                                    ]}
                                    paginationModel={paginationModel}
                                    paginationMode="server"
                                    onPaginationModelChange={(
                                      newPaginationModel
                                    ) => {
                                      setPaginationModel(newPaginationModel);
                                      fetchLeave(newPaginationModel, sortModel);
                                    }}
                                    sortModel={sortModel}
                                    sortingMode="server"
                                    onSortModelChange={(newSortModel) => {
                                      setSortModel(newSortModel);
                                      fetchLeave(paginationModel, newSortModel);
                                    }}
                                    disableSelectionOnClick
                                    isRowSelectable={() => false}
                                  />
                                </Box>
                              </div>
                            </CardBody>
                          </Card>
                          <Card className="mb-4">
                            <CardHeader>
                              <strong>Approvers</strong>
                            </CardHeader>
                            <CardBody>
                              {leaveApprovers && leaveApprovers.length > 0 ? (
                                <div className="mb-4">
                                  <h5 className="fw-bold">Client Approvers</h5>

                                  {leaveApprovers.map((approver, index) => {
                                    const selectedId =
                                      selectedLeaveApprovers[approver.id]
                                        ?.source_id;
                                    const fullName = getApproverFullName(
                                      approver,
                                      selectedId,
                                      clientUsers,
                                      associateList,
                                      admins
                                    );

                                    return (
                                      <div
                                        key={approver.id}
                                        className="row align-items-center mb-2"
                                      >
                                        {/* Approver Label */}
                                        <div className="col-md-3 fw-bold">
                                          Approver {index + 1}
                                        </div>

                                        {/* Capitalized Label Column */}
                                        <div className="col-md-4">
                                          {capitalizeLabel(approver.value)}
                                        </div>

                                        {/* Name or "Not selected" */}
                                        <div className="col-md-5">
                                          {fullName ? (
                                            <div className="form-control-plaintext">
                                              {fullName}
                                            </div>
                                          ) : (
                                            <div className="text-muted">
                                              Not selected
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              ) : (
                                <div
                                  className="text-center p-4"
                                  style={{ marginTop: '20px' }}
                                >
                                  No Records Found
                                </div>
                              )}
                            </CardBody>
                          </Card>
                          <Card className="mb-4">
                            <CardHeader>
                              <strong>Rest Days</strong>
                            </CardHeader>
                            <CardBody>
                              <div className="container-fluid d-flex">
                                <div
                                  style={{ width: '15rem' }}
                                  className="p-2 m-2"
                                >
                                  <strong>Rest Days</strong>
                                  <p className="pt-2">
                                    View employee rest days
                                  </p>
                                </div>

                                <div style={{ margin: '2rem' }}>
                                  {[
                                    { key: 'Mon', label: 'Monday' },
                                    { key: 'Tue', label: 'Tuesday' },
                                    { key: 'Wed', label: 'Wednesday' },
                                    { key: 'Thu', label: 'Thursday' },
                                    { key: 'Fri', label: 'Friday' },
                                    { key: 'Sat', label: 'Saturday' },
                                    { key: 'Sun', label: 'Sunday' },
                                  ].map((day) => {
                                    const isChecked = restDays.includes(
                                      day.key
                                    );

                                    return (
                                      <div key={day.key} className="mb-2">
                                        <label
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                          }}
                                        >
                                          {isChecked ? (
                                            <i className="fas fa-check text-success me-2"></i>
                                          ) : (
                                            <i className="fas fa-times text-muted me-2"></i>
                                          )}
                                          <span>{day.label}</span>
                                        </label>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  className="card bg-white text-dark shadow rounded mb-4"
                  style={{ marginLeft: '3rem', marginRight: '3rem' }}
                >
                  <div className="card-body">
                    <div className="container-fluid d-flex">
                      <div style={{ width: '15rem' }} className="p-2 m-2">
                        <strong>Fixed Schedule</strong>
                        <p className="pt-2 text-muted">
                          Manage fixed schedule for employee as Team Support
                        </p>
                      </div>
                      <div className="flex-grow-1 p-2 m-2">
                        <div className="table-responsive">
                          <table className="table-borderless w-100">
                            <tbody>
                              {associate.client &&
                                toWeekDaysArrayFull(
                                  moment(),
                                  associate.client.start_day
                                ).map((day) => (
                                  <tr key={moment(day).format('DDDD')}>
                                    <th width="33%" className="pb-3">
                                      {moment(day).format('dddd')}
                                    </th>
                                    <td width="33%">
                                      {fixedSchedules
                                        .filter(
                                          (schedule) =>
                                            schedule.site.client_id ==
                                            associate.client.id
                                        )
                                        .map((schedule, index) => {
                                          if (
                                            day.day() === schedule.day &&
                                            schedule.shift !== null
                                          ) {
                                            return (
                                              <div
                                                key={`${schedule.id}-${index}`}
                                              >
                                                {schedule.site.name}
                                              </div>
                                            );
                                          }
                                        })}
                                    </td>
                                    <td width="33%">
                                      {fixedSchedules
                                        .filter(
                                          (schedule) =>
                                            schedule.site.client_id ==
                                            associate.client.id
                                        )
                                        .map((schedule, index) => {
                                          if (
                                            day.day() === schedule.day &&
                                            schedule.shift !== null
                                          ) {
                                            return (
                                              <div
                                                key={`${schedule.id}-${index}`}
                                              >
                                                {to12Hr(
                                                  schedule.shift.start_time
                                                )}{' '}
                                                -{' '}
                                                {to12Hr(
                                                  schedule.shift.end_time
                                                )}
                                              </div>
                                            );
                                          }
                                        })}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {activeTab === 'Shift Logs' && (
              <div
                className="card bg-white text-dark shadow rounded mb-4"
                style={{ marginLeft: '3rem', marginRight: '3rem' }}
              >
                <div
                  className="py-1"
                  style={{
                    margin: 20,
                    justifyContent: 'center',
                  }}
                >
                  <Row>
                    <Form.Group as={Col} md="12">
                      <strong>Shift Logs</strong>
                      <p>
                        Filter the employee shift logs by selecting start date
                        and end date.
                      </p>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} md="6">
                      <strong>Start Date</strong>
                      <Form.Control
                        type="date"
                        value={shiftPeriod.shift_period_start}
                        onChange={(e) => periodFilterHandler('start', e)}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter start date.
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <strong>End Date</strong>
                      <Form.Control
                        type="date"
                        value={shiftPeriod.shift_period_end}
                        onChange={(e) => periodFilterHandler('end', e)}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter end date.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                </div>
                <div className="card-body">
                  <div className="container-fluid d-flex flex-column">
                    {loading && (
                      <Row style={{ margin: 25 }}>
                        <p>Loading, Please wait...</p>
                        <SpringLoader style={{ marginTop: 200 }} />
                      </Row>
                    )}
                    {!loading && scheduleLogs.length > 0 && (
                      <Row
                        style={{
                          justifyContent: 'center',
                        }}
                      >
                        <a href="#" onClick={handleDownloadShiftLogs}>
                          Click here to download Shift Logs result.
                        </a>
                      </Row>
                    )}
                    {!loading && scheduleLogs.length > 0
                      ? scheduleLogs.map((month, index) => (
                          <div key={index} className="p-2 m-2 mb-4">
                            <h5 className="mb-3">{month.monthYear}</h5>
                            <div className="table-responsive border rounded">
                              <table className="table table-bordered mb-0">
                                <thead className="border-bottom">
                                  <tr>
                                    <th width="17%">Date</th>
                                    <th className="text-center" width="15%">
                                      Site
                                    </th>
                                    <th className="text-center" width="15%">
                                      Shift
                                    </th>
                                    <th className="text-center" width="15%">
                                      Total Hours
                                    </th>
                                    <th className="text-center" width="10%">
                                      Attendance
                                    </th>
                                    <th>Remarks</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {month.dates.map((date, dateIndex) => {
                                    return date.schedules.map(
                                      (schedule, scheduleIndex) => {
                                        return (
                                          <tr key={scheduleIndex}>
                                            {scheduleIndex === 0 && (
                                              <td
                                                rowSpan={date.schedules.length}
                                                style={{
                                                  whiteSpace: 'nowrap',
                                                  verticalAlign: 'middle',
                                                }}
                                              >
                                                {date.date}
                                              </td>
                                            )}

                                            <td
                                              style={{
                                                whiteSpace: 'nowrap',
                                                verticalAlign: 'middle',
                                              }}
                                              className="text-center text-muted"
                                            >
                                              {schedule.site}
                                            </td>
                                            <td
                                              style={{
                                                whiteSpace: 'nowrap',
                                                verticalAlign: 'middle',
                                              }}
                                              className="text-center text-muted"
                                            >
                                              {schedule.shift}
                                              <br />
                                              {schedule.start_time.substr(
                                                0,
                                                5
                                              )}{' '}
                                              -{schedule.end_time.substr(0, 5)}
                                            </td>
                                            <td
                                              style={{
                                                whiteSpace: 'nowrap',
                                                verticalAlign: 'middle',
                                              }}
                                              className="text-center text-muted"
                                            >
                                              {schedule.total_hours}
                                            </td>
                                            <td
                                              className="text-center"
                                              style={{
                                                whiteSpace: 'nowrap',
                                                verticalAlign: 'middle',
                                              }}
                                            >
                                              {schedule.status === 2 ||
                                              schedule.status === 3 ||
                                              schedule.status === 4 ? (
                                                <i className="fas fa-check text-success"></i>
                                              ) : (
                                                <i className="fas fa-times text-danger"></i>
                                              )}
                                            </td>
                                            <td className="text-muted">
                                              {`${schedule.statusString}`}
                                              {(schedule.status === 6 ||
                                                schedule.status === 7) &&
                                                (schedule.reason
                                                  ? `: ${schedule.reason}`
                                                  : '')}
                                            </td>
                                          </tr>
                                        );
                                      }
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        ))
                      : !loading && (
                          <div className="text-center">No data available</div>
                        )}
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'Rewards' && (
              <div className="d-flex flex-row">
                <div className="tab-content flex-grow-1">
                  <div
                    id={`${_.kebabCase('Redeemed Rewards')}`}
                    role="tabpanel"
                    aria-labelledby={`${_.kebabCase('Redeemed Rewards')}-tab`}
                    className={`tab-pane fade ${
                      activeSubTab === 'Redeemed Rewards' ? 'show active' : ''
                    }`}
                  >
                    <div
                      className="card bg-white text-dark shadow rounded mb-4"
                      style={{ marginLeft: '3rem', marginRight: '3rem' }}
                    >
                      <div className="card-body">
                        <div className="flex-row align-items-center justify-content-end pb-2">
                          <Searchbar
                            search={(e) => handleSearchCarts(e)}
                            placeholder="Search redeemed rewards"
                            width="100%"
                          />
                        </div>
                        {redeemedRewards.length > 0 ? (
                          redeemedRewards
                            .sort((a, b) =>
                              moment(a.createdAt).isBefore(moment(b.createdAt))
                                ? 1
                                : -1
                            )
                            .map((cart) => (
                              <div
                                key={cart.id}
                                className="bg-white rounded border mb-3"
                                // onClick={() => history.push(`rewards/carts/${cart.id}`)}
                              >
                                <div className="my-2 pb-2 px-2 d-flex flex-row justify-content-between align-items-center border-bottom w-100">
                                  <div
                                    className="text-muted"
                                    style={{ fontSize: '0.7rem' }}
                                  >
                                    {cart.is_collected != 3 && (
                                      <>
                                        {' '}
                                        Redeemed on:{' '}
                                        {moment(cart.createdAt).format(
                                          'D MMM YYYY, hh:mm:ssa'
                                        )}
                                      </>
                                    )}
                                  </div>
                                  <button
                                    className="btn btn-sm btn-brand adjust-fs adjust-shadow"
                                    onClick={() =>
                                      history.push(
                                        `/rewards/collection/${cart.id}`
                                      )
                                    }
                                  >
                                    Go To Details Page
                                  </button>
                                </div>

                                <div id="itemDetailContainer">
                                  {cart.items.length > 0 &&
                                    cart.items.map((item) => (
                                      <div
                                        key={item.id}
                                        className="d-flex justify-content-between align-items-center mb-2 px-2"
                                      >
                                        <div
                                          className="img-responsive"
                                          style={{
                                            position: 'relative',
                                            background: `url(${
                                              item &&
                                              item.reward_item.images.length > 0
                                                ? `${SERVER_URL}/${item.reward_item.images[0].url}`
                                                : placeholderBackground
                                            }) no-repeat center center`,
                                            backgroundSize: 'contain',
                                            height: '75px',
                                            width: '75px',
                                          }}
                                        ></div>
                                        <div className="d-flex flex-column flex-grow-1 ms-3">
                                          <div
                                            className="p-0 m-0"
                                            style={{ fontSize: '0.9rem' }}
                                          >
                                            {item &&
                                              _.truncate(
                                                item.reward_item.name,
                                                {
                                                  length: 24,
                                                }
                                              )}
                                          </div>
                                          <div
                                            className="text-brand mt-1"
                                            style={{ fontSize: '0.8rem' }}
                                          >
                                            {item &&
                                            item.reward_item.type ===
                                              'redeemable'
                                              ? `${
                                                  item.reward_item
                                                    .redeem_points *
                                                  item.quantity
                                                } Points`
                                              : 'Free'}
                                          </div>
                                          <div
                                            className="mt-1 text-muted"
                                            style={{ fontSize: '0.8rem' }}
                                          >
                                            x{item && item.quantity}
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                                <div
                                  id="totalContainer"
                                  className="d-flex align-items-center justify-content-between my-2 p-2 w-100 border-top"
                                >
                                  <span
                                    className={`badge rounded-pill ${
                                      !cart.is_collected && !cart.is_mailing
                                        ? 'bg-warning'
                                        : !cart.is_mailed && cart.is_mailing
                                        ? 'bg-warning'
                                        : cart.is_mailed && cart.is_mailing
                                        ? 'bg-success'
                                        : cart.is_collected == 1
                                        ? 'bg-success'
                                        : cart.is_collected == 3
                                        ? 'bg-danger'
                                        : 'bg-warning'
                                    }`}
                                  >
                                    {!cart.is_collected && !cart.is_mailing
                                      ? 'Pending Collection'
                                      : !cart.is_mailed && cart.is_mailing
                                      ? 'Pending Mailing'
                                      : cart.is_mailed && cart.is_mailing
                                      ? 'Mailed'
                                      : cart.is_collected == 1
                                      ? 'Collected'
                                      : cart.is_collected == 3
                                      ? 'Cancelled'
                                      : ''}
                                  </span>
                                  <div style={{ fontSize: '0.8rem' }}>
                                    {cart.items.reduce(
                                      (total, item) => total + item.quantity,
                                      0
                                    )}{' '}
                                    item
                                    {cart.items.reduce(
                                      (total, item) => total + item.quantity,
                                      0
                                    ) > 1 && 's'}
                                    , Total:{' '}
                                    <span className="fw-bold">
                                      {cart.total === 0
                                        ? 'Free'
                                        : `${cart.total} Points`}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))
                        ) : (
                          <div className="bg-white rounded shadow mb-3 py-2 px-3">
                            No items redeemed.
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    id={`${_.kebabCase('Transaction History')}`}
                    role="tabpanel"
                    aria-labelledby={`${_.kebabCase(
                      'Transaction History'
                    )}-tab`}
                    className={`tab-pane fade ${
                      activeSubTab === 'Transaction History'
                        ? 'show active'
                        : ''
                    }`}
                  >
                    <div
                      className="card bg-white text-dark shadow rounded mb-4"
                      style={{ marginLeft: '3rem', marginRight: '3rem' }}
                    >
                      <div className="card-body">
                        <TransactionHistory data={transactionHistory} />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="d-flex flex-column nav nav-pills"
                  style={{
                    width: '250px',
                    minWidth: '250px',
                  }}
                >
                  {['Redeemed Rewards', 'Transaction History'].map(
                    (tab, index) => (
                      <a
                        key={index}
                        className={`nav-link mb-2 ${
                          activeSubTab === tab
                            ? 'active adjust-fs adjust-shadow'
                            : ''
                        }`}
                        id={`${_.kebabCase(tab)}-tab`}
                        data-toggle="pill"
                        href={`#${_.kebabCase(tab)}`}
                        role="tab"
                        onClick={() => setActiveSubTab(tab)}
                        aria-controls={`${_.kebabCase(tab)}`}
                        aria-selected="false"
                      >
                        {tab}
                      </a>
                    )
                  )}
                </div>
              </div>
            )}

            {activeTab === 'Claims' && (
              <>
                <NavLink to="/claims" style={{ color: 'inherit' }}>
                  <div>
                    <i className="fas fa-chevron-left pe-2 mb-4"></i> Go To
                    Claims Module
                  </div>
                </NavLink>
                <MUIDataTable
                  data={claims}
                  columns={columns}
                  options={options}
                ></MUIDataTable>
              </>
            )}

            {activeTab === 'Leave Summary' && (
              <>
                <NavLink
                  to="/leave-credits-filling"
                  style={{ color: 'inherit' }}
                >
                  <div>
                    <i className="fas fa-chevron-left pe-2 mb-4"></i> Go To
                    Leave Credit & Filling Module
                  </div>
                </NavLink>
                <MUIDataTable
                  data={leaveSummary}
                  columns={columnsLeaveSummary}
                  options={options}
                ></MUIDataTable>
              </>
            )}
          </div>
        </div>
      </div>
      <Modal showModal={showAssignPointsModal}>
        <div className="h-100">
          <form
            className="d-flex flex-column justify-content-between flex-grow-1 h-100"
            onSubmit={(e) => handleSubmitAsssignPoints(e)}
          >
            <h6>Assign Reward Points</h6>
            <div className="mb-2">
              <label htmlFor="assignPoints">Points</label>
              <input
                type="number"
                min="0"
                className="form-control w-auto my-2 adjust-fs"
                id="assignPoints"
                placeholder="Reward Points"
                value={
                  JSON.parse(reason).points > 0
                    ? JSON.parse(reason).points
                    : points
                }
                disabled={JSON.parse(reason).points > 0}
                onChange={(e) => setPoints(e.target.value)}
              />
            </div>
            <div className="mb-2">
              <label htmlFor="assignReason">Reason</label>
              <select
                name="assignPointReason"
                id="assignPointReason"
                className="form-select w-50 my-2 adjust-fs"
                value={reason}
                onChange={({ target: { value } }) => {
                  setReason(value);
                }}
              >
                <option value="0">Choose Reason</option>
                {reasons.length > 0 &&
                  reasons.map(
                    (reason) =>
                      reason.active && (
                        <option key={reason.id} value={JSON.stringify(reason)}>
                          {reason.reason}
                        </option>
                      )
                  )}
              </select>
            </div>
            <div className="mb-2">
              <label htmlFor="assignRemarks">Remarks</label>
              <textarea
                rows="5"
                style={{ resize: 'none' }}
                className="form-control adjust-fs my-2"
                id="assignRemarks"
                placeholder={defaulValue}
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              ></textarea>
            </div>
            <div className="d-flex justify-content-end mt-auto pt-3 border-top">
              <button
                type="button"
                onClick={() => handleCloseAssignPointModal()}
                className="btn btn-outline-brand adjust-fs adjust-shadow"
                style={{ width: '12rem' }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                style={{ width: '12rem' }}
              >
                Assign
              </button>
            </div>
          </form>
        </div>
      </Modal>
      <Modal showModal={showLeaveSummaryModal}>
        <div className="h-100">
          <form
            className="d-flex flex-column justify-content-between flex-grow-1 h-100"
            onSubmit={handleLeaveSubmit} // Fixed: removed arrow function
          >
            {/* Header with X button */}
            <div className="mb-4 d-flex justify-content-between align-items-center">
              <h5 className="mb-0 fw-semibold text-dark">
                Manage Leave Credit
              </h5>
              <button
                type="button"
                onClick={handleCloseLeaveSummaryModal} // Fixed: removed arrow function
                className="btn-close"
                aria-label="Close"
              ></button>
            </div>

            {/* Form Body */}
            <div className="flex-grow-1">
              {/* Leave Type Selection */}
              <div className="row mb-4 g-3">
                <div className="col-4">
                  <label
                    htmlFor="leaveType"
                    className="form-label fw-medium mb-2"
                  >
                    Leave Type <span className="text-danger">*</span>
                  </label>
                  {modalMode === 'add' && (
                    <select
                      id="leaveType"
                      className="form-select adjust-fs"
                      value={leaveTypeId}
                      onChange={(e) => setLeaveTypeId(e.target.value)}
                      required
                    >
                      <option value="">Select Leave Type</option>
                      {leaveTypes.map((leave) => (
                        <option key={leave.id} value={leave.id}>
                          {leave.name}
                        </option>
                      ))}
                    </select>
                  )}
                  {modalMode === 'edit' && (
                    <div className="mt-2">
                      <span className="form-control-plaintext fw-light">
                        {leaveTypeName}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {/* Leave Allocation Section */}
              <div className="mb-4">
                <div className="row g-3">
                  <div className="col-4">
                    <label
                      htmlFor="maxPerYear"
                      className="form-label fw-medium mb-2"
                    >
                      Max Per Year
                    </label>
                    <input
                      type="number"
                      className="form-control adjust-fs"
                      id="maxPerYear"
                      value={maxLeaves}
                      onChange={(e) => setMaxLeaves(e.target.value)}
                      min="0"
                      step="0.5"
                      placeholder="0"
                    />
                  </div>
                  <div className="col-4">
                    <label
                      htmlFor="available"
                      className="form-label fw-medium mb-2"
                    >
                      Available
                    </label>
                    <input
                      type="number"
                      className="form-control adjust-fs"
                      id="available"
                      value={available}
                      onChange={(e) => setAvailable(e.target.value)}
                      min="0"
                      step="0.5"
                      placeholder="0"
                    />
                  </div>
                  {modalMode === 'edit' && (
                    <div className="col-4">
                      <label className="form-label fw-medium mb-2">Taken</label>
                      <div className="form-control-plaintext fw-light ms-2">
                        {taken || 0}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Active Period Section */}
              <div className="mb-4">
                <div className="row g-3">
                  <div className="col-4">
                    <label
                      htmlFor="activeFrom"
                      className="form-label fw-medium mb-2"
                    >
                      Active From <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      id="activeFrom"
                      className="form-control adjust-fs"
                      value={activeDate}
                      onChange={(e) => setActiveDate(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-4">
                    <label
                      htmlFor="activeTo"
                      className="form-label fw-medium mb-2"
                    >
                      Active To <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      id="activeTo"
                      className="form-control adjust-fs"
                      value={expiryDate}
                      onChange={(e) => setExpiryDate(e.target.value)}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Actions */}
            <div className="d-flex justify-content-end mt-auto pt-3 border-top">
              <button
                type="submit"
                className="btn btn-brand adjust-fs adjust-shadow"
                style={{ width: '12rem' }}
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </Modal>

      {showRewardSidebar && (
        <RewardSidebar
          activeSidebar={showRewardSidebar}
          setActiveSidebar={setShowRewardSidebar}
          data={transactionHistory}
        />
      )}
    </>
  );
};

export default withRouter(AssociateDetail);
